import React from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";
import logo from "../assets/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          {/* <div className="footer-section">
            <img
              src={logo}
              alt="Swarna Shringar Logo"
              className="footer-logo"
            />
          </div> */}
          <div className="footer-section">
            <div className="footer-logo">
              <h3>Swarna Shringar </h3>
              <p>Artificial Jewelry</p>

              <p className="footer-description">
                Crafting timeless elegance through exquisite artificial jewelry.
                We bring you the finest collection of necklaces, earrings,
                bracelets, and more at affordable prices.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/collections">Collections</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              {/* <li>
                <Link to="/cart">Shopping Cart</Link>
              </li> */}
            </ul>
          </div>

          {/* Categories */}
          {/* <div className="footer-section">
            <h4>Categories</h4>
            <ul className="footer-links">
              <li>
                <Link to="/collections?category=set">Bridal Jewelery</Link>
              </li>
              <li>
                <Link to="/collections?category=set">Bridal Chuda</Link>
              </li>
              <li>
                <Link to="/collections?category=necklace">Necklaces</Link>
              </li>
              <li>
                <Link to="/collections?category=earrings">Earrings</Link>
              </li>
              <li>
                <Link to="/collections?category=bangles">Bangles</Link>
              </li>
            </ul>
          </div> */}

          {/* Customer Service */}
          {/* <div className="footer-section">
            <h4>Customer Service</h4>
            <ul className="footer-links">
              <li><Link to="/shipping">Shipping Info</Link></li>
              <li><Link to="/returns">Returns & Exchanges</Link></li>
              <li><Link to="/size-guide">Size Guide</Link></li>
              <li><Link to="/care-instructions">Care Instructions</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </div> */}

          {/* Contact Info */}

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              {/* Phone Number */}
              <div className="contact-item">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <a href="tel:+917828551893" className="contact-link">
                  +91 78285 51893
                </a>
              </div>

              {/* Email */}
              <div className="contact-item">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <a
                  href="mailto:shringarswarna1@gmail.com"
                  className="contact-link"
                >
                  shringarswarna1@gmail.com
                </a>
              </div>

              {/* Location */}
              <div className="contact-item">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span>Gwalior, Madhya Pradesh, India</span>
              </div>
            </div>
          </div>

          {/* Connect with Us Section */}
          <div className="footer-section">
            <h4>Connect with us on Social Media</h4>
            <div className="social-links">
              {/* Facebook */}
              <a
                href="https://www.facebook.com/share/1A8hwz7ezg/"
                className="social-link"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/_swarna_shringar_?igsh=MTlncGRucGNuaGZj"
                className="social-link"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10zm-5 4a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm4.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
                </svg>
              </a>

              {/* YouTube */}
              <a
                href="https://www.youtube.com/@SwarnaShringar"
                className="social-link"
                aria-label="YouTube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Swarna Shringar. All rights reserved.</p>
            {/* <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/cookies">Cookie Policy</Link>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
